export enum AppDataEventObject {
  PAGE = 'page',
  ANNOUNCEMENT = 'announcement',
  POLICY_VIOLATION_WARNING = 'policy_violation_warning',
  USER_SURVEY = 'user_survey',
}
